<template>
  <div class="page-box">
    <ul class="app-view" v-if="versionUrl">
      <li>
        <img :src="anyangIcon"/>
        <!-- <p>{{ appName }}</p> -->
      </li>
      <van-button
        size="mini"
        class="down-app-btn"
        @click="downApp"
        v-if="versionUrl">打开APP
      </van-button>
    </ul>
    <div class="view-box audio-view-box" v-if="versionUrl"></div>
    <div :class="versionUrl?'margintop':''" @click.stop="controlsShowFun" class="video-box">
      <!-- <video
        v-if="!noplay && begin"
        x5-video-player-type="h5"
        webkit-playsinline
        :playsinline="playsinline"
        :src="playUrl"
        ref="video"
        class="video"
        autoplay
      ></video> -->
      <div class="video" v-if="!noplay && begin">
        <VueAliplayerV2
              x5-video-player-type="h5"
              webkit-playsinline
              :playsinline="playsinline"
              :options="option"
              ref="video"
              style="height: 100%"
              :sourceUrl="playUrl">
        </VueAliplayerV2>
      </div>
      <div
        class="zhanwei"
        v-if="!begin && countDownSwitch == 0 && !endimg"
      ></div>
      <div class="endimg" v-if="endimg"></div>
      <div class="playbtn" v-if="!noplay && !endimg && clicked">
        <i class="begin-play" @click="videoPlay"></i>
      </div>
      <div class="live-box">
        <!-- 当前在线:{{people}}人 -->
        <div class="live-status" style="display: flex">
          <span v-if="page.liveState == 0" class="unstart">未开始</span>
          <span v-if="page.liveState == 1" class="liveing">直播中</span>
          <span v-if="page.liveState == 2 && page.playPath" class="playback"
            >回放中</span
          >
          <span v-else-if="page.liveState == 2" class="live-end">已结束</span>
        </div>
      </div>
      <div class="noplay" v-if="noplay"></div>
      <div class="count" v-if="!begin">
        <div class="daoji">
          <p>直播倒计时</p>
          <van-count-down :time="time" @finish="onfinish">
            <template #default="timeData">
              <span class="block">{{ time1(timeData.hours) }}</span>
              <span class="colon">:</span>
              <span class="block">{{ time1(timeData.minutes) }}</span>
              <span class="colon">:</span>
              <span class="block">{{ time1(timeData.seconds) }}</span>
            </template>
          </van-count-down>
        </div>
      </div>
      <transition name="van-fade">
        <div
          class="controls-box"
          v-show="controlsShow && !videoControls.openTD && !noplay"
          @click.stop="controlsHiddenFun"
        >
          <ul class="controls-box-title">
            <li v-show="page.activityAuthor">{{ activityAuthor }}</li>
            <li>
              <span class="el-icon-user"></span>
              <span style="margin-left: 5px">{{ people }}</span>
            </li>
          </ul>
          <!-- <ul class="controls-box-controls">
            <li @click.stop="videoControls.play ? videoPause() : videoPlay()">
              <van-icon name="pause" v-show="videoControls.play" />
              <van-icon name="play" v-show="!videoControls.play" />
            </li>
            <li @click.stop="openTDWind" v-if="page.multiCamera == 0">
              <img class="zhankai" src="@/assets/img/shangll.png" alt="" />
            </li>
            <li @click.stop="videoFullScreen">
              <van-icon class="enlarge" name="enlarge" />
            </li>
          </ul> -->
        </div>
      </transition>
      <transition name="van-slide-up">
        <div class="TD-box" v-show="videoControls.openTD">
          <ul class="TD-list" v-show="page.activityFrameList">
            <li
              v-for="(val, ind) in page.activityFrameList"
              :key="ind"
              :class="{ 'TD-focus': val.active }"
              @click="frameChange(val, ind)"
            >
              <van-image
                width="102"
                height="67"
                fit="cover"
                :src="val.frameImageLow || val.frameImage"
              />
              <p>{{ val.frameTitle }}</p>
            </li>
          </ul>
          <img
            @click="closeTDWind"
            class="shouqi"
            src="@/assets/img/shadj.png"
            alt=""
          />
        </div>
      </transition>
    </div>

    <div class="ios-box" v-if="IOS && iosfull">
      <video
        x5-video-player-type="h5"
        webkit-playsinline
        playsinline
        @click.stop="iosControlsShowFun"
        :src="playUrl"
        ref="iosvideo"
        class="iosvideo"
        autoplay
      ></video>
      <transition name="van-fade">
        <div
          class="controls-box-ios"
          v-show="iosControlsShow"
          @click.stop="controlsHiddenFun"
        >
          <ul class="controls-box-title"></ul>
          <ul class="controls-box-controls">
            <li
              @click.stop="
                iosVideoControls.play ? iosVideoPause() : iosVideoPlay()
              "
            >
              <van-icon name="pause" v-show="iosVideoControls.play" />
              <van-icon name="play" v-show="!iosVideoControls.play" />
            </li>
            <li @click.stop="iosVideoFullScreen">
              <i class="iconfont icon-xiaoping"></i>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <van-tabs
      v-model="active"
      v-if="editableTabs && editableTabs.length > 0"
      color="#5F93FF"
      border
      @change="tabsClick"
      swipeable
    >
      <van-tab
        :title="val.menuName"
        v-for="(val, ind) in editableTabs || []"
        :key="ind"
        :name="val.menuType"
      >
        <div class="tabs-box">
          <tim
            ref="childMethod"
            :userinfo="wxuserInfo"
            :giftList="page.activityPropList"
            :tvId="$route.query.id"
            v-if="active == 0"
            @replay="onreplay"
          ></tim>
          <div
            class="tv-info tv-introduce"
            v-if="active == 1"
            v-html="val.menuContent"
          ></div>
          <!-- 图文直播 -->
          <div class="tv-info" v-if="active == 2">
            <zsimgText ref="childMethod2" :userinfo="wxuserInfo"></zsimgText>
          </div>
          <!-- 互动问答 -->
          <div class="tv-info" v-if="active == 3">
            <zsInteraction
              ref="childMethod3"
              :userinfo="wxuserInfo"
            ></zsInteraction>
          </div>
          <!-- 边看边买 -->
          <div class="tv-info" v-if="active == 4">
            <zsStore :userinfo="wxuserInfo" ref="childMethod4"></zsStore>
          </div>
          <!-- 直播推荐 -->
          <div class="tv-info" v-if="active == 5">
            <zsLiveRecommend
              :userinfo="wxuserInfo"
              ref="childMethod5"
            ></zsLiveRecommend>
          </div>
        </div>
      </van-tab>
          <div class="footer">
      <img :src="require('../assets/img/footer.png')" alt="">
    </div>
    </van-tabs>

  </div>
</template>

<script>
import * as sctipts from "@/service/share";
import axios from "@/utils/server";
import Bus from "@/eventBus/index.js";
import { menuList } from "@/api/tvlive";
import zsimgText from "@/components/img&text/index.vue";
import zsStore from "@/components/store/index.vue";
import zsLiveRecommend from "@/components/liveRecommend/index.vue";
import zsInteraction from "@/components/interaction/index.vue";
import { mapState, mapMutations } from "vuex";
import { liveHasLogin } from "@/utils/app.js";
import sdk from "@/utils/share"; // 引入sdk.
export default {
  data() {
    return {
      anyangIcon: require('../assets/img/logo.png'),
      originType:'',
      versionUrl: "",
      appName: "",
      appIcon: '',
      wxuserInfo: {}, //登录数据
      noplay: false,
      iosControlsShow: false,
      iosfull: false,
      clicked: true,
      endimg: false,
      begin: false,
      endtime: 9000,
      activityAuthor: "",
      countDownSwitch: 0,
      time: 5000,
      userinfo: {},
      controlsShow: false,
      videoControls: {
        play: false,
        openTD: false,
        fullScreen: false,
      },
      iosVideoControls: {
        play: false,
        openTD: false,
        fullScreen: false,
      },
      controlsTimer: "",
      active: 0,
      playUrl: "",
      page: {},
      twzblist: [],
      toptwzblist: [],
      editableTabs: [],
      activityId: "",
      uuid: "",
      ws: null,
      info: {
        origin: "web",
        nickname: "游客",
        id: "游客" + Math.round(Math.random() * 1000),
        headimgurl:
          "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      },
      count1: 0,
      count2: 0,
      count3: 0,
      people: 0,
      peopleinterval: null,
      option: {
        isLive: true, //切换为直播流的时候必填
        width: "100%",
        height: "100%",
        useH5Prism: true,
        diagnosisButtonVisible: false,
        autoplay: false,
        preload: true,
        mediaType: "video",
        language: "zh-custom", // 自定义语言包
        languageTexts: {
          // 播放器自定义提示文字
          "zh-custom": {
            Video_Error: "这是测试文字...", // 视频播放异常
            Error_Load_M3U8_Timeout_Text: "获取m3u8文件超时", // 获取m3u8文件超时
            Error_Load_M3U8_Failed_Text: "获取m3u8文件失败", //  获取m3u8文件失败
            Live_Abrot: "这是测试文字...", // 直播信号中断
            Error_Not_Found: "这是测试文字...", // 播放地址不存在
            Refresh_Text: "刷新",
            Retry: "重试",
            Detection_Text: "诊断CA",
          },
        },
      },
    };
  },
  computed: {
    ...mapState(["inWX", "IOS", "Android"]),
    playsinline() {
      // app判断
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        //ios端
        return true;
      }
    },
  },
  created() {
    window.sessionStorage.setItem("id", this.$route.query.id);
    window.sessionStorage.setItem("tvType", this.$route.query.tvType);
    //登录app后更新用户信息
    Bus.$on("update:userInfo", (data) => {
      let userinfo = data;
      if (userinfo) {
        this.wxuserInfo = {
          nickname: JSON.parse(userinfo).data.userNick,
          headimgurl:
            JSON.parse(userinfo).data.userHeadPath ||
            "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
          id: JSON.parse(userinfo).data.userId,
          origin: "app",
        };
      }
      console.log("获取用户信息", data);
      // window.location.reload();
    });
    if (this.inWX) {
      let userinfo = sessionStorage.getItem("userinfo");
      if (userinfo) {
        this.wxuserInfo = JSON.parse(userinfo);
        this.wxuserInfo = {
          nickname: JSON.parse(userinfo).nickname,
          headimgurl:
            JSON.parse(userinfo).headimgurl ||
            "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
          id: JSON.parse(userinfo).openid,
          origin: "wechat",
        };
      } else {
        // this.$router.replace({ name: "login", query: { id: this.$route.query.id,tvType: 5 } });
      }
    } else {
      liveHasLogin({
        success: () => {
          console.log("已登录");
          let userinfo = sessionStorage.getItem("userinfo");
          if (userinfo) {
            this.wxuserInfo = {
              nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
              headimgurl: JSON.parse(JSON.parse(userinfo)).data.userHeadPath,
              id: JSON.parse(JSON.parse(userinfo)).data.userId,
              origin: "app",
            };
          }
        },
        failed: () => {
          console.log("未登录");
          // opneLoginPane();
        },
      });
      if (this.IOS) {
        // getLoginStatus();
        let userinfo = sessionStorage.getItem("userinfo");
        if (userinfo) {
          this.wxuserInfo = {
            nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
            headimgurl:
              JSON.parse(JSON.parse(userinfo)).data.userHeadPath ||
              "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
            id: JSON.parse(JSON.parse(userinfo)).data.userId,
            origin: "app",
          };
        }
      } else if (this.Android) {
        // getLoginStatus();
        let userinfo = sessionStorage.getItem("userinfo");
        if (userinfo) {
          this.wxuserInfo = {
            nickname: JSON.parse(JSON.parse(userinfo)).data.userNick,
            headimgurl:
              JSON.parse(JSON.parse(userinfo)).data.userHeadPath ||
              "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
            id: JSON.parse(JSON.parse(userinfo)).data.userId,
            origin: "app",
          };
        }
      } else {
        this.wxuserInfo = {
          // origin:'web',
          // nickname:'主持人',
          // id:'主持人',
          // headimgurl:"https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
        };
      }
    }
    this.getVideoDetail();
  },
  components: {
    VueAliplayerV2:()=>import("@/components/playerbox/livePlayer"),
    tim: () => import("@/components/tmi"),
    zsimgText,
    zsStore,
    zsLiveRecommend,
    zsInteraction,
  },
  mounted() {
    if (this.equipmentType() == "iOS") {
      this.originType = 0;
    } else if (this.equipmentType() == "Android") {
      this.originType = 1;
    } else {
      this.originType = 3;
    }
    sctipts
        .getAppUrl({
          type: this.originType,
          bundleID: this.$route.query.bundleID
        })
        .then(({
          data
        }) => {
          if (data.status == 0) {
            if (data.data) {
              this.versionUrl = data.data.versionUrl;
              this.appName = data.data.applicationName;
              this.appIcon = data.data.applicationHeadPath;
              this.appScheme = data.data.applicationUrlScheme
            }
          } else {
            console.log(data.desc);
          }
    });
    window.addEventListener("storage", (event) => {
      if (event.key === "userinfo") {
        console.log(event.newValue);
      }
    });
    // 获取menu
    this.getMenuList(this.$route.query.id);
    // 获取在线人数
    clearInterval(this.peopleinterval);
    this.peopleinterval = null;
    this.peopleinterval = setInterval(() => {
      this.getPeople(this.$route.query.id);
    }, 10000);
  },
  destroyed() {
    clearInterval(this.peopleinterval);
    this.peopleinterval = null;
  },
  methods: {
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    downApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(1)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(1)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    // 获取视频详情
    getVideoDetail() {
      //获取页面详情
      axios
        .get(`/activity/allInfo/${this.$route.query.id}`)
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data.rewardSwitch == 0) {
              this.setGiftBtn(false);
            } else {
              this.setGiftBtn(true);
            }
            this.time = data.data.activityBeginTime - Date.now();
            this.countDownSwitch = data.data.countDownSwitch;
            this.activityAuthor = data.data.activityAuthor;
            this.page = data.data;

            // if (this.inWX) {
            //   const url = location.href.split('#')[0];
            //   // const url ='http://waplive.zsvideo-data.com.cn?id=8994181846467201503&tvType=5'
            //   const dataForWeixin = {
            //     title: this.page.activityTitle, // 分享标题
            //     desc: this.page.passagewayName, // 分享内容
            //     linkurl: url, // 分享链接
            //     img: this.page.activityImageIcon, // 分享内容显示的图片(图片必须是正方形的链接)
            //   };
            //   sdk.getJSSDK(url,dataForWeixin);
            // }

            this.startime =
              parseInt(data.data.activityBeginTime) - parseInt(Date.now());
            if (this.startime > 0) {
              this.begin = false;
              setTimeout(() => {
                setTimeout(() => {
                  this.getVideoDetail();
                }, 1000);
              }, this.startime);
            } else {
              this.begin = true;
            }
            this.endtime =
              parseInt(data.data.activityEndTime) - parseInt(Date.now());
            if (this.endtime > 0) {
              setTimeout(() => {
                console.log("直播结束!");
                this.getVideoDetail();
              }, this.endtime);
            }
            document.title = this.page.activityTitle;
            if (this.page.multiCamera == 0) {
              // 多机位
              // passagewayState 通道状态 3无直播流
              this.passagewayState =
                this.page.activityFrameList[0].passagewayState;
              this.page.activityFrameList[0].active = true;
              if (this.page.activityFrameList[0].passagewayType == 1) {
                //推流
                if (this.page.liveState === 2) {
                  // 直播结束
                  if (
                    this.passagewayState == 1 ||
                    this.passagewayState == 2 ||
                    this.passagewayState == 6
                  ) {
                    //通道状态
                    if (
                      this.page.playPath != null &&
                      this.page.playbackFlag === 1
                    ) {
                      // 是否回放
                      this.playUrl = this.page.playPath;
                      this.noplay = false; // 隐藏展位图
                    } else {
                      this.noplay = true; // 展示展位图
                    }
                  }
                } else if (this.page.liveState === 1) {
                  // 直播进行中
                  this.noplay = false;
                  this.playUrl = this.page.activityFrameList[0].hlsPlayPath;
                  this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                } else {
                  // 直播未开始
                  this.noplay = true;
                  this.playUrl = this.page.activityFrameList[0].hlsPlayPath;
                  this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                }
              } else if (this.page.activityFrameList[0].passagewayType == 0) {
                // 拉流
                // 拉流 转推 retweetedFlag = 1 取 hlsPlayPath, 不转推 retweetedFlag = 0 取   pullPath
                if (this.page.activityFrameList[0].retweetedFlag == 1) {
                  // 转推
                  if (this.page.liveState === 2) {
                    // 直播结束
                    if (
                      this.passagewayState == 1 ||
                      this.passagewayState == 2 ||
                      this.passagewayState == 6
                    ) {
                      //通道状态
                      if (
                        this.page.playPath != null &&
                        this.page.playbackFlag === 1
                      ) {
                        // 是否回放
                        this.playUrl = this.page.playPath;
                        this.noplay = false; // 隐藏展位图
                      } else {
                        this.noplay = true; // 展示展位图
                      }
                    }
                  } else if (this.page.liveState === 1) {
                    // 直播进行中
                    this.noplay = false;
                    this.playUrl = this.page.activityFrameList[0].hlsPlayPath;
                    this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                  } else {
                    // 直播未开始
                    this.noplay = true;
                    this.playUrl = this.page.activityFrameList[0].hlsPlayPath;
                    this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                  }
                } else {
                  // 不转推
                  if (this.page.liveState === 2) {
                    // 直播结束
                    if (
                      this.passagewayState == 1 ||
                      this.passagewayState == 2 ||
                      this.passagewayState == 6
                    ) {
                      //通道状态
                      if (
                        this.page.playPath != null &&
                        this.page.playbackFlag === 1
                      ) {
                        // 是否回放
                        this.playUrl = this.page.playPath;
                        this.noplay = false; // 隐藏展位图
                      } else {
                        this.noplay = true; // 展示展位图
                      }
                    }
                  } else if (this.page.liveState === 1) {
                    // 直播进行中
                    this.noplay = false;
                    this.playUrl = this.page.activityFrameList[0].pullPath;
                    this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                  } else {
                    // 直播未开始
                    this.noplay = true;
                    this.playUrl = this.page.activityFrameList[0].pullPath;
                    this.pullPath = this.page.activityFrameList[0].rtmpPushPath;
                  }
                }
              }
            } else if (this.page.multiCamera == 1) {
              // 单机位
              this.passagewayState = this.page.passagewayState;
              if (this.page.passagewayType == 1) {
                // 推流
                if (this.page.liveState === 2) {
                  // 直播结束
                  if (
                    this.passagewayState == 1 ||
                    this.passagewayState == 2 ||
                    this.passagewayState == 6
                  ) {
                    //通道状态
                    if (
                      this.page.playPath != null &&
                      this.page.playbackFlag === 1
                    ) {
                      // 是否回放
                      this.playUrl = this.page.playPath;
                      this.noplay = false; // 隐藏展位图
                    } else {
                      this.noplay = true; // 展示展位图
                    }
                  }
                } else if (this.page.liveState === 1) {
                  // 直播进行中
                  this.noplay = false;
                  this.playUrl = this.page.hlsPlayPath;
                  this.pullPath = this.page.rtmpPushPath;
                } else {
                  // 直播未开始
                  this.noplay = true;
                  this.playUrl = this.page.hlsPlayPath;
                  this.pullPath = this.page.rtmpPushPath;
                }
              } else if (this.page.passagewayType == 0) {
                // 拉流 转推 retweetedFlag = 1 取 hlsPlayPath, 不转推 retweetedFlag = 0 取   pullPath
                if (this.page.retweetedFlag == 1) {
                  if (this.page.liveState === 2) {
                    // 直播结束
                    if (
                      this.passagewayState == 1 ||
                      this.passagewayState == 2 ||
                      this.passagewayState == 6
                    ) {
                      //通道状态
                      if (
                        this.page.playPath != null &&
                        this.page.playbackFlag === 1
                      ) {
                        // 是否回放
                        this.playUrl = this.page.playPath;
                        this.noplay = false; // 隐藏展位图
                      } else {
                        this.noplay = true; // 展示展位图
                      }
                    }
                  } else if (this.page.liveState === 1) {
                    // 直播进行中
                    this.noplay = false;
                    this.playUrl = this.page.hlsPlayPath;
                    this.pullPath = this.page.rtmpPushPath;
                  } else {
                    // 直播未开始
                    this.noplay = true;
                    this.playUrl = this.page.hlsPlayPath;
                    this.pullPath = this.page.rtmpPushPath;
                  }
                } else {
                  if (this.page.liveState === 2) {
                    // 直播结束
                    if (
                      this.passagewayState == 1 ||
                      this.passagewayState == 2 ||
                      this.passagewayState == 6
                    ) {
                      //通道状态
                      if (
                        this.page.playPath != null &&
                        this.page.playbackFlag === 1
                      ) {
                        // 是否回放
                        this.playUrl = this.page.playPath;
                        this.noplay = false; // 隐藏展位图
                      } else {
                        this.noplay = true; // 展示展位图
                      }
                    }
                  } else if (this.page.liveState === 1) {
                    // 直播进行中
                    this.noplay = false;
                    this.playUrl = this.page.pullPath;
                    this.pullPath = this.page.rtmpPushPath;
                  } else {
                    // 直播未开始
                    this.noplay = true;
                    this.playUrl = this.page.pullPath;
                    this.pullPath = this.page.rtmpPushPath;
                  }
                }
              }
            }
          }
        });
    },
    ...mapMutations(["setGiftBtn"]),
    // 获取在线人数
    getPeople(tvId) {
      axios.get(`${this.$api.people}?activityId=${tvId}`).then(({ data }) => {
        if (data.status == 0) {
          this.people = data.data;
        }
      });
    },
    // tabs切换为图文直播
    tabsClick(name) {
      switch (name) {
        case 0:
          this.$nextTick(() => {
            if (this.$refs.childMethod[0]) {
              this.$refs.childMethod[0].socketOpen(
                "chat",
                this.$route.query.id,
                this.wxuserInfo
              );
            }
          });
          break;
        case 2:
          this.$nextTick(() => {
            if (this.$refs.childMethod2[0]) {
              this.$refs.childMethod2[0].socketOpen(
                "live",
                this.$route.query.id,
                this.wxuserInfo
              );
            }
          });
          break;
        case 3:
          this.$nextTick(() => {
            if (this.$refs.childMethod3[0]) {
              this.$refs.childMethod3[0].socketOpen(
                "qa",
                this.$route.query.id,
                this.wxuserInfo
              );
            }
          });
          break;
        // case 4:
        //   this.$nextTick(() => {
        //     if (this.$refs.childMethod4[0]) {
        //       this.$refs.childMethod4[0].getCommodity(this.$route.query.id)
        //     }
        //   })
        //   break;
        // case 5:
        //   this.$nextTick(() => {
        //     if (this.$refs.childMethod5[0]) {
        //       this.$refs.childMethod5[0].getRecommend(this.$route.query.id)
        //     }
        //   })
        //   break;
      }
    },
    // 获取tabs栏目
    getMenuList(tvId) {
      menuList(tvId, 1).then((res) => {
        this.editableTabs = res.data.data;
        this.activeName = this.editableTabs[0].menuType;
        setTimeout(() => {
          this.tabsClick(this.activeName);
        }, 500);
      });
    },
    onreplay() {
      this.videoPlay();
    },
    onfinish() {
      this.countDownSwitch = 0;
      this.begin = true;
    },
    time1(val) {
      return val < 10 ? "0" + val : val;
    },
    playVideo() {
      this.videoPlay();
    },
    //显示控制条
    controlsShowFun() {
      this.controlsShow = true;
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsTimer = setTimeout(() => {
        this.controlsShow = false;
      }, 5000);
    },
    iosControlsShowFun() {
      this.iosControlsShow = true;
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsTimer = setTimeout(() => {
        this.iosControlsShow = false;
      }, 2000);
    },
    //隐藏控制条
    controlsHiddenFun() {
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.controlsShow = false;
    },

    iosControlsHiddenFun() {
      if (this.controlsTimer) {
        clearTimeout(this.controlsTimer);
      }
      this.iosControlsShow = false;
    },
    //全屏方法
    videoFullScreen() {
      if (this.IOS) {
        this.iosfull = true;
        this.videoPause();
        this.iosVideoPlay();
      } else {
        this.videoPlay();
        let ele = this.$refs["video"];
        if (ele.requestFullscreen) {
          ele.requestFullscreen();
        } else if (ele.mozRequestFullScreen) {
          ele.mozRequestFullScreen();
        } else if (ele.webkitRequestFullScreen) {
          ele.webkitRequestFullScreen();
        }
        this.videoControls.play = false;
      }
    },

    iosVideoFullScreen() {
      this.iosfull = false;
      this.videoPlay();
    },
    //播放
    videoPlay() {
      this.clicked = false;
      this.controlsShowFun();
      this.videoControls.play = true;
      this.$refs["video"].play();
    },
    iosVideoPlay() {
      this.iosControlsShowFun();
      this.iosVideoControls.play = true;
      this.$nextTick(() => {
        this.$refs["iosvideo"].play();
      });
    },
    //暂停播放
    videoPause() {
      this.controlsShowFun();
      this.videoControls.play = false;
      this.$refs["video"].pause();
    },
    iosVideoPause() {
      this.iosControlsShowFun();
      this.iosVideoControls.play = false;
      this.$refs["iosvideo"].pause();
    },
    //打开通道菜单
    openTDWind() {
      this.controlsHiddenFun();
      this.videoControls.openTD = true;
    },
    //关闭通道菜单
    closeTDWind() {
      this.videoControls.openTD = false;
      this.controlsShowFun();
    },
    // 机位切换
    frameChange(val, ind) {
      this.page.activityFrameList = this.page.activityFrameList.map(
        (value, index) => {
          if (index == ind) {
            value.active = true;
          } else {
            value.active = false;
          }
          return value;
        }
      );
      this.passagewayState = val.passagewayState;
      if (val.passagewayType == 1) {
        //推流
        if (this.page.liveState === 2) {
          // 直播结束 直播状态
          if (
            this.passagewayState == 1 ||
            this.passagewayState == 2 ||
            this.passagewayState == 6
          ) {
            //通道状态
            if (val.playPath != null && val.playbackFlag === 1) {
              // 是否回放
              this.playUrl = val.playPath;
              this.noplay = false; // 隐藏展位图
            } else {
              this.noplay = true; // 展示展位图
            }
          }
        } else if (this.page.liveState === 1) {
          // 直播进行中
          this.noplay = false;
          this.playUrl = val.hlsPlayPath;
          this.pullPath = val.rtmpPushPath;
        } else {
          // 直播未开始
          this.noplay = true;
          this.playUrl = val.hlsPlayPath;
          this.pullPath = val.rtmpPushPath;
        }
      } else if (val.passagewayType == 0) {
        // 拉流 转推 retweetedFlag = 1 取 hlsPlayPath, 不转推 retweetedFlag = 0 取   pullPath
        if (val.retweetedFlag == 1) {
          if (this.page.liveState === 2) {
            // 直播结束
            if (
              this.passagewayState == 1 ||
              this.passagewayState == 2 ||
              this.passagewayState == 6
            ) {
              //通道状态
              if (val.playPath != null && val.playbackFlag === 1) {
                // 是否回放
                this.playUrl = val.playPath;
                this.noplay = false; // 隐藏展位图
              } else {
                this.noplay = true; // 展示展位图
              }
            }
          } else if (this.page.liveState === 1) {
            // 直播进行中
            this.noplay = false;
            this.playUrl = val.hlsPlayPath;
            this.pullPath = val.rtmpPushPath;
          } else {
            // 直播未开始
            this.noplay = true;
            this.playUrl = val.hlsPlayPath;
            this.pullPath = val.rtmpPushPath;
          }
        } else {
          if (this.page.liveState === 2) {
            // 直播结束
            if (
              this.passagewayState == 1 ||
              this.passagewayState == 2 ||
              this.passagewayState == 6
            ) {
              //通道状态
              if (val.playPath != null && val.playbackFlag === 1) {
                // 是否回放
                this.playUrl = val.playPath;
                this.noplay = false; // 隐藏展位图
              } else {
                this.noplay = true; // 展示展位图
              }
            }
          } else if (this.page.liveState === 1) {
            // 直播进行中
            this.noplay = false;
            this.playUrl = val.pullPath;
            this.pullPath = val.rtmpPushPath;
          } else {
            // 直播未开始
            this.noplay = true;
            this.playUrl = val.pullPath;
            this.pullPath = val.rtmpPushPath;
          }
        }
      }
      this.videoPause();
      this.videoPlay();
      this.closeTDWind();
    },
  },
  //登出
  beforeDestroy() {
    // if (this.tim) {
    //   this.tim.logout();
    // }
  },
};
</script>

<style scoped>
.footer img{
  width: 100%;
  height: 100%;
  display: block;
}
.down-app-btn {
  width: 81px;
  height: 32px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #be1928;
  background-color: #be1928;
}
.app-view {
  width: 100%;
  max-width: 677PX;
  height: 50PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13PX;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fafafa;
  border-bottom: 1PX solid #eee;
  z-index: 99999;
}

.app-view > li:nth-child(1) {
  height: 44PX;
}

.app-view > li:nth-child(1) > img {
  height: 44PX;
  display: block;
  float: left;
}

.app-view > li:nth-child(1) > p {
  font-size: 14PX;
  color: #333333;
  float: left;
  margin-left: 8PX;
  line-height: 44PX;
}

.app-view > li:nth-child(2) {
  height: 44PX;
  overflow: hidden;
}

.app-view > li:nth-child(2) > a {
  display: block;
  width: 81PX;
  height: 26PX;
  background-color: #518dfa;
  border: none;
  color: #fff;
  font-size: 14PX;
  outline: none;
  text-align: center;
  line-height: 26PX;
  text-decoration: none;
  border-radius: 5PX;
}
.icon-xiaoping {
  font-size: 30px;
}

.twzb {
  font-size: 14px;
}

.twzb .twcontent {
  width: 300px;
  padding: 5px;
}

.text-msg {
  display: flex;
  margin: 10px 0;
}

.text-msg > div {
  flex-shrink: 0;
  /* margin-left: 15px; */
  margin-right: 6px;
}

.text-msg > span {
  color: #8a8a8a;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  flex-shrink: 0;
  margin-right: 6px;
}

.text-msg > p {
  color: #333;
  font-size: 14px;
  line-height: 20px;
  margin-right: 15px;
  text-align: justify;
}

.noplay {
  top: 0;
  position: absolute;
  background-image: url("../assets/img/noplay.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
  z-index: 9;
}
.live-box {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  padding: 3px 5px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.351);
  z-index: 2001;
}
.iosvideo {
  width: 100%;
  height: 100vh;
  background-color: #000;
  z-index: 99999;
  object-fit: contain;
  position: fixed;
  top: 0;
  left: 0;
}

.ios-box {
  width: 100%;
  position: relative;
  top: 0px;
  overflow: hidden;
  /* transform: rotate(50deg); */
}

.playbtn {
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-image: url("../assets/img/playbg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.playbtn .begin-play {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.endimg {
  top: 0;
  position: absolute;
  background-image: url("../assets/img/jieshu.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}

.shouqi {
  width: 16px;
  position: absolute;
  bottom: 10px;
  left: calc(50% - 8px);
}

.qwe {
  opacity: 0;
}

.zhanwei {
  position: absolute;
  background-image: url("../assets/img/jingcaiz.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}

.fabu {
  position: absolute;
  color: #fff;
  z-index: 99;
  background-color: #303030;
  border-radius: 8px;
  font-size: 14px;
  top: 5%;
  left: 6%;
  padding: 2px 6px;
}

.daoji {
  height: 200px;
  margin-top: 90px;
}

.colon {
  display: inline-block;
  margin: 0 10px;
  color: #5ee2ff;
  font-size: 20px;
}

.block {
  display: inline-block;
  width: 22px;
  color: #5ee2ff;
  font-size: 24px;
  text-align: center;
}

.count {
  text-align: center;
  position: absolute;
  width: 80%;
  background-image: url("../assets/img/daoji.png");
  background-size: 100% 100%;
  background-position: center;
  width: 100%;
  height: 100%;
}

.count p {
  color: #5ee2ff;
  margin-bottom: 10px;
  font-size: 18px;
}

.page-box {
  overflow: hidden;
  height: 100%;
}

.video-box {
  width: 100%;
  height: 210px;
  overflow: hidden;
  position: relative;
  
}
.margintop{
  margin-top:12px;
}
.controls-box {
  z-index: 999;
  width: 100%;
  height: 210px;
  /* background-image: url("../assets/img/video_bg.png"); */
  background-repeat: repeat-x;
  background-position: center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.controls-box-title {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
}

.zhankai {
  width: 16px;
  height: 16px;
}

.controls-box-title > li {
  height: 20px;
  margin-left: 15px;
  background-color: #000;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border-radius: 5px;
}

.controls-box-controls {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0 15px;
  box-sizing: border-box;
}

.controls-box-controls > li {
  font-size: 26px;
  color: #fff;
}

.controls-box-ios {
  width: 100%;
  height: 470px;
  position: fixed;
  bottom: 1vh;
  z-index: 99999999;
}

.controls-box-ios .controls-box-controls {
  width: 370px;
}

.TD-box {
  z-index: 999;
  width: 100%;
  height: 210px;
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("../assets/img/video_bg.png");
  background-repeat: repeat-x;
  background-position: center;
  background-size: contain;
}

.TD-list {
  width: 100%;
  overflow-x: auto;
  height: 100px;
  position: absolute;
  top: 80px;
  left: 0;
  display: flex;
}

.TD-list > li {
  flex-shrink: 0;
  width: 102px;
  height: 90px;
  margin-left: 7px;
}

.TD-list > li:first-child {
  margin-left: 15px;
}

.TD-list > li:last-child {
  margin-right: 15px;
}

.TD-list > li > div {
  display: block;
  border-radius: 4px;
  overflow: hidden;
  background-color: #000;
  border: 1px solid transparent;
}

.TD-list > li > p {
  color: #fff;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
  margin-top: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.TD-list > .TD-focus > div {
  border: 1px solid #5f93ff;
}

.TD-list > .TD-focus > p {
  color: #5f93ff;
}

.back-bottom-btn {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 8px;
  color: #fff;
  font-size: 30px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: left;
}

.video {
  width: 100%;
  height: 210px;
  display: block;
  background-color: #000;
}

.tabs-box {
  width: 100%;
  height: calc(100vh - 290px);
  overflow: hidden;
  overflow-y: auto;
  background-color: #fff;
}

.tv-info {
  width: calc(100% - 30px);
  height: calc(100% - 25px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 15px 25px 15px;
}
.tv-introduce {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  padding-top: 20px;
}
.tv-introduce img {
  width: 100%;
  opacity: 1;
  border-radius: 0px;
}
</style>
<style>
.van-tabs__line{
  width: 15px;
}
.tv-info img {
  max-width: 100% !important;
  object-fit: contain;
  height: auto !important;
}
.van-tabs .van-tab.van-tab--active{
  color: #333333;
  font-weight: bold;
}
.van-tabs .van-tabs__line{
  background-color: #be1928 !important; 
}
</style>